import { StoreButtons } from "./StoreButtons";
import { Link } from "react-router-dom";
import { BRAND } from "../../data/content";
import { useScannerDetail } from "./ScannerDetail";
import { BrandLabel } from "./BrandLabel";

export const Footer = () => {
  const { openDetail } = useScannerDetail();
  const go = (id) => {
    const el = document.querySelector(id);
    if (!el) return;
    if (window.lenis) {
      window.lenis.scrollTo(el, { offset: -80 });
    } else {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
  <footer className="border-t border-line bg-white">
    <div className="mx-auto max-w-[1240px] px-5 md:px-8 py-14">
      <div className="grid gap-10 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2.5">
            <img src={BRAND.logo} alt="WhatThe?" className="h-9 w-9 rounded-xl" />
            <span className="text-lg font-bold tracking-tight text-ink">
              WhatThe<span className="text-food-accent">?</span> Scan
            </span>
          </div>
          <p className="mt-3 max-w-xs text-[15px] text-slate leading-relaxed">
            Smarter choices, inside and out. Two scanners for Food & Body. Buy
            one or both, top up scans if you need more. No mandatory
            subscriptions.
          </p>

          <div className="mt-6 max-w-sm">
            <p className="text-xs font-semibold uppercase tracking-[0.15em] text-slate mb-3">
              Download now
            </p>
            <StoreButtons />
          </div>
        </div>

        <div className="md:col-span-7 grid grid-cols-3 gap-8 text-sm md:justify-items-end">
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-slate mb-3">
              Scanners
            </p>
            <ul className="space-y-2.5 text-ink/70">
              <li>
                <button
                  data-testid="footer-scanner-food"
                  onClick={() => openDetail("food")}
                  className="text-left transition-colors hover:text-food-accent"
                >
                  <BrandLabel text="WhatThe? Food" />
                </button>
              </li>
              <li>
                <button
                  data-testid="footer-scanner-body"
                  onClick={() => openDetail("body")}
                  className="text-left transition-colors hover:text-food-accent"
                >
                  <BrandLabel text="WhatThe? Body" />
                </button>
              </li>
            </ul>
          </div>
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-slate mb-3">
              Product
            </p>
            <ul className="space-y-2.5 text-ink/70">
              <li>
                <button
                  data-testid="footer-link-pricing"
                  onClick={() => go("#pricing")}
                  className="text-left transition-colors hover:text-food-accent"
                >
                  Pricing
                </button>
              </li>
              <li>
                <button
                  data-testid="footer-link-why"
                  onClick={() => go("#why")}
                  className="text-left transition-colors hover:text-food-accent"
                >
                  <BrandLabel text="Why WhatThe? Scan" />
                </button>
              </li>
              <li>
                <a
                  data-testid="footer-link-support"
                  href="mailto:info@whatthescan.app"
                  className="text-left transition-colors hover:text-food-accent"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-slate mb-3">
              Legal
            </p>
            <ul className="space-y-2.5 text-ink/70">
              <li>
                <Link
                  to="/terms"
                  data-testid="footer-link-terms"
                  className="text-left transition-colors hover:text-food-accent"
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy-policy"
                  data-testid="footer-link-privacy"
                  className="text-left transition-colors hover:text-food-accent"
                >
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-line pt-6">
        <p className="text-xs text-slate">
          © {new Date().getFullYear()} WhatThe? Ingredient Scanner ·{" "}
          <a href={`https://${BRAND.domain}`} className="text-ink/70 hover:text-ink transition-colors">
            {BRAND.domain}
          </a>{" "}
          · Made in Australia 🇦🇺
        </p>
        <p className="text-xs text-slate">
          Pay once · No subscriptions · Zero tracking
        </p>
      </div>
    </div>
  </footer>
  );
};
